import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { JSX } from '@gov-design-system-ce/components/dist/types/components';
import { GovCollapsible } from '@gov-design-system-ce/react';

interface ToggleButtonProps {
	children?: ReactNode;
	size?: JSX.GovButton['size'];
	direction?: 'up' | 'down';
	showLabel?: string;
	hideLabel?: string;
	wcagShowLabel?: string;
	className?: string;
	open?: boolean;
	onOpenChange?: (opened: boolean) => void;
}

export const ToggleButton = ({
	children,
	wcagShowLabel,
	size = 'm',
	direction = 'down',
	showLabel,
	hideLabel,
	className,
	open,
	onOpenChange,
}: ToggleButtonProps) => {
	const { t } = useTranslation();
	return (
		<GovCollapsible
			size={size}
			direction={direction}
			className={className}
			onOpenChange={onOpenChange}
			open={open}
			labelCollapsed={showLabel || t('vice-informaci.zobrazit')}
			labelExpanded={hideLabel || t('vice-informaci.skryt')}
			aria-label={wcagShowLabel || t('vice-informaci.wcag.label')}>
			{children}
		</GovCollapsible>
	);
};
